import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { CreateItemGroupComponent } from '../create-item-group/create-item-group.component';
import { ScoringTypeEnum, ScoringTypeNameEnum, ScoringTypeName1 } from 'src/app/shared/config/questions.config';
import { Subject, Subscription } from 'rxjs';
import { TestService } from '@services/test.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
@Component({
  selector: 'app-item-group-list',
  templateUrl: './item-group-list.component.html',
  styleUrls: ['./item-group-list.component.scss']
})
export class ItemGroupListComponent implements OnInit, OnDestroy {
  @Input() testUUID;
  // @Input() previewData;
  @Output() closeExistingItemEvent = new EventEmitter<boolean>();
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['itemGroups', 'scoringType', 'updated', 'action'];
  isNoItemGroup: Boolean = true;
  itemGroupList: any;
  ScoringTypeNameEnum = ScoringTypeNameEnum;
  ScoringTypeName1 = ScoringTypeName1;
  @Input()
  get pageIndex(): number { return this._pageIndex; }
  set pageIndex(pageIndex: number) {
    this._pageIndex = pageIndex;
    this._changeDetectorRef.markForCheck();
  }
  _pageIndex: number = 0;
  @ViewChild('addItemGroup', { static: true }) addItemGroup: CreateItemGroupComponent;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if (this.itemGroupList) {
      this.itemGroupList.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  testServiceSubscription: Subscription;
  previewData: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  showPaginator = false;
  langCode : string;
  constructor(
    private itemService: ItemService,
    private dialog: MatDialog,
    private testService: TestService,
    private notificationService: NotificationService,
    private _changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
  ) {
    this.langCode = localStorage.getItem('language');
  }

  ngOnInit(): void {
    this.getItemGroup();
    this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
      (resData) => {
        this.previewData = resData?.data;
    },
    (error) =>
    () => this.testServiceSubscription.unsubscribe()) || undefined;
  }

  getItemGroup() {
    const getItemGroupList = this.itemService.getItemGroupList(this.testUUID).subscribe(data => {
      if (data) {

        this.assignAndCreateOrder(data.data.sort((a, b) => (a.itemGroupOrder - b.itemGroupOrder)))
        this.preparePagination();
      }
      getItemGroupList.unsubscribe();
    });
  }

  itemGroupsList(event: any) {
    this.itemGroupList = event;
    this.assignAndCreateOrder(this.itemGroupList.sort((a, b) => (a.itemGroupOrder - b.itemGroupOrder)));
    this.preparePagination();
  }

  createItemGroupDialog(): void {
    let data;
    this.addItemGroup.showPopup(data, this.previewData);
  }

  editItemGroup(itemGroup: any) {
    this.addItemGroup.showPopup(itemGroup, this.previewData);
  }

  gotoItems() {
    this.closeExistingItemEvent.emit(true);
  }

  deleteItemGroup(questions: any) {
    const dialogRef = this.dialog.open(DelMessageComponent,
      { data:
        {
          message: this.translate.instant('testId.TabItems.itemGroupList.deletePopup.message'),
          buttonText: {
            ok: this.translate.instant('testId.TabItems.itemGroupList.deletePopup.btnYes'),
            cancel: this.translate.instant('testId.TabItems.itemGroupList.deletePopup.btnNo')
          } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.itemService.deleteItemGroup(this.testUUID, questions.itemGroupId).subscribe(data => {
          if (data) {
            this.itemService.getItemGroupList(this.testUUID).subscribe(data => {
              this.itemService.itemgrouplist.next(data.data);
              this.assignAndCreateOrder(data.data.sort((a, b) => (a.itemGroupOrder - b.itemGroupOrder)));
              this.preparePagination();
            });
            this.notificationService.success(data.message);
          }
        }, (error: any) => { this.webErrorService.handleAPIErrors(error, '', true, 'warn'); });
      }
    });
  }

  //#region  [Ordering Part]
  public orderIndex: any[];
  private tableDataSource: any;
  public reuseProp = {
    incomingIdProperty: 'itemGroupId',
    incomingOrderProperty: 'itemGroupOrder',
    saveIdProperty: 'itemcategoryid',
    saveOrderProperty: 'ItemCategoryOrdertoRender',
  };

  public tablePageConfig = { length: 0, pageIndex: 0, pageSize: 10, previousPageIndex: 0 };

  public onPageChange(event: any) { this.tablePageConfig = event; }

  public dragAndDropEventHandler(event: any) {
    const prevIndex = this.tableDataSource.findIndex((d) => d === event.item.data);
    const indexToSet = (this.tablePageConfig.pageIndex * this.tablePageConfig.pageSize) + event.currentIndex;
    this.moveItemOrder(this.tableDataSource, prevIndex, indexToSet);
    this.moveItemOrder(this.orderIndex, prevIndex, indexToSet);
    this.recreateIndex(this.tableDataSource, this.reuseProp.incomingOrderProperty);
    this.recreateIndex(this.orderIndex, this.reuseProp.saveOrderProperty);
    this.preparePagination();
    this.saveOrderItemList();
  }

  private assignAndCreateOrder(data: any[]): void {
    this.orderIndex = [];
    this.tableDataSource = [];
    if (data && data.length) {
      // const questionOrder = data.sort((a, b) => (a[this.reuseProp.incomingOrderProperty] < b[this.reuseProp.incomingOrderProperty] ? -1 : 1)); // this line commented - created and updated data should on top
      data.forEach((item) => {
        this.orderIndex.push({
          [this.reuseProp.saveIdProperty]: item[this.reuseProp.incomingIdProperty],
          [this.reuseProp.saveOrderProperty]: item[this.reuseProp.incomingOrderProperty],
        });
        this.tableDataSource.push(item);
      });
      this.recreateIndex(this.orderIndex, this.reuseProp.saveOrderProperty);
    }
  }

  private moveItemOrder(dataList: any[], fromIndex: number, toIndex: number): void {
    var element = dataList[fromIndex];
    dataList.splice(fromIndex, 1);
    dataList.splice(toIndex, 0, element);
  }

  private recreateIndex(dataList: any[], propertyToCreateIndex: string): void {
    // dataList.forEach(item => item[propertyToCreateIndex] = dataList.indexOf(item) + 1);
  }

  //#endregion
  private saveOrderItemList() {
    this.orderIndex.forEach((a, index) => {
      a.ItemCategoryOrdertoRender = index + 1;
    });
    this.itemService.saveOrderItemGroup(this.testUUID, this.orderIndex).subscribe(() => { });
  }

  private preparePagination() {
    this.itemGroupList = new MatTableDataSource(this.tableDataSource);
    this.tablePageConfig.length = this.tableDataSource?.length;
    if (this.tableDataSource.length == 0) {
      this.isNoItemGroup = true;
    } else {
      this.isNoItemGroup = false;
      this.itemGroupList.sort = this.sort;
      if (this._pageIndex) { this._pageIndex = 0; }
      this._pageIndex = this.tablePageConfig.pageIndex;

      setTimeout(() => {
        if(this.itemGroupList.paginator) {
          this.itemGroupList.paginator = this.paginator;
          this.showPaginator = true
           // ------Set translation for pagination------
           this.translate.stream([
            'testId.TabItems.itemGroupList.pagination.pageLabel',
            'testId.TabItems.itemGroupList.pagination.firstPage',
            'testId.TabItems.itemGroupList.pagination.lastPage',
            'testId.TabItems.itemGroupList.pagination.nextPage',
            'testId.TabItems.itemGroupList.pagination.prevPage'
          ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
              this.itemGroupList.paginator._intl.itemsPerPageLabel = translation['testId.TabItems.itemGroupList.pagination.pageLabel'];
              this.itemGroupList.paginator._intl.firstPageLabel = translation['testId.TabItems.itemGroupList.pagination.firstPage'];
              this.itemGroupList.paginator._intl.lastPageLabel = translation['testId.TabItems.itemGroupList.pagination.lastPage'];
              this.itemGroupList.paginator._intl.nextPageLabel = translation['testId.TabItems.itemGroupList.pagination.nextPage'];
              this.itemGroupList.paginator._intl.previousPageLabel = translation['testId.TabItems.itemGroupList.pagination.prevPage'];

              this.itemGroupList.paginator._intl.changes.next();
          });
        }
      });

    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
